export default __webpack_public_path__ + "static/media/winentretien_team.c65b14b8.jpg";